import React from 'react';

export function Malta(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H256.5V342H0V0Z" fill="white"/>
      <path d="M256.5 0H513V342H256.5V0Z" fill="#CF142B"/>
      <rect x="30" y="25" width="70" height="70" fill="none" stroke="#CF142B" strokeWidth="5"/>
      <rect x="30" y="25" width="35" height="35" fill="#CF142B"/>
      <rect x="65" y="60" width="35" height="35" fill="#CF142B"/>
    </svg>
  );
}
